import { ParameterType } from '@/study-search/enums';

import {FilterOptionInformation } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';
import { AttendanceFilterOptionValue } from '@studyportals/search-filters/server-side';

class DistanceLearningAttendanceFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DELIVERY_METHOD,
			[
				new FilterOptionInformation('Fully online', AttendanceFilterOptionValue.ONLINE, 'online', 'Online'),
				new FilterOptionInformation('Blended', AttendanceFilterOptionValue.BLENDED, '', ''),
			],
			[AttendanceFilterOptionValue.ONLINE],
			true,
		);
	}
}

export default new DistanceLearningAttendanceFilterDefinition();
